import styled from '@emotion/styled';

export const InfoTextWrapper = styled.p`
  font-style: italic;
  font-size: ${({theme}) => theme.fontSizes[300]};
`;
